/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.publicAmazonCatalogue.internal

import features.publicAmazonCatalogue.models.PublicRewardsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class PublicAmazonCatalogueServiceImpl : PublicAmazonCatalogueService {

    private val publicAmazonCatalogueRequest = PublicAmazonCatalogueRequest()

    override suspend fun getPublicAmazonCatalogue(
        overrideHeaders : Map<String, String>?,
        pageNumber: Int,
        perPage: Int,
        keywords: String?,
        filters: String?    ): Result<PublicRewardsModel> {
        return publicAmazonCatalogueRequest.getPublicAmazonCatalogue(
            overrideHeaders = overrideHeaders,
            pageNumber = pageNumber,
            perPage = perPage,
            keywords = keywords,
            filters = filters        ).toModel()
    }
}
